import { Reducer } from 'redux';
import { ReauthState, ReauthActions, MEMBER_REAUTH__SAVE_MEMBER_PROFILE, MEMBER_REAUTH__SET_ACCESSIBLE_STEP, MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA, MEMBER_REAUTH__SEND_OTP_DONE, MEMBER_REAUTH__UPDATE_CACHE, MEMBER_REAUTH__RESET_CACHE } from './types';

const initialState: ReauthState = {
  static: {},
  process: {
    accessibleSteps: [],
    clauses: {},
    otpAuth: {}
  }
};

const reauthReducer: Reducer<ReauthState, ReauthActions> = (state = initialState, action): ReauthState => {
  switch (action.type) {
    // 緩存會員資料
    case MEMBER_REAUTH__SAVE_MEMBER_PROFILE: {
      return { ...state, static: { ...state.static, memberProfile: action.payload.data } };
    }
    // 設置可訪問步驟
    case MEMBER_REAUTH__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「同意相關告知事項」(Step-1) 頁面資料
    case MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA: {
      return { ...state, process: { ...state.process, clauses: { ...state.process.clauses, data: action.payload.data } } };
    }
    // 發送 OTP 驗證碼 完成
    case MEMBER_REAUTH__SEND_OTP_DONE: {
      return { ...state, process: { ...state.process, otpAuth: { ...state.process.otpAuth, otp: action.payload.response } } };
    }
    // 更新流程資料緩存
    case MEMBER_REAUTH__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case MEMBER_REAUTH__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default reauthReducer;
